import { render, staticRenderFns } from "./IconDialog.vue?vue&type=template&id=78fd485b&scoped=true&"
import script from "./IconDialog.vue?vue&type=script&lang=js&"
export * from "./IconDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconDialog.vue?vue&type=style&index=0&id=78fd485b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd485b",
  null
  
)

export default component.exports